import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

import HomePage from "./Home/index.tsx";
import PrivacyPage from "./Privacy/index.jsx";
import TermsPage from "./Terms/index.jsx";
// import AboutPage from "./About/index";
// import ContactPage from "./Contact/index";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* 
        <Route path="/contact" element={<ContactPage />} /> */}
      </Routes>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/27816155344"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          right: "20px",
          bottom: "20px",
          backgroundColor: "#25D366",
          color: "white",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "30px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
          zIndex: 1000,
          textDecoration: "none"
        }}
      >
        <FaWhatsapp />
      </a>

    </Router>
  );
}